export default __webpack_public_path__ + "static/media/main-image.0327eb24.jpg";